import React from "react";
import {
  CPanel,
  CLink,
  CFontIcon,
  H4,
  P,
  Flex
} from "@appcues/component-library";
import { SUPPORT_EMAIL } from "constants/externalAppcuesResources";

const InvoiceMessage = () => {
  const invoiceHeader = "You pay via invoice";

  return (
    <CPanel>
      <CPanel.Header>
        <H4 type="secondary">Billing Details</H4>
      </CPanel.Header>
      <Flex flexDirection="column" justifyContent="center" textAlign="center">
        <CFontIcon
          className="fas fa-envelope"
          color="$gray-5"
          fontSize="2rem"
          marginBottom={12}
        />
        <P bold>{invoiceHeader}</P>
        <P>
          If you would like a copy, email us at <CLink>{SUPPORT_EMAIL}</CLink>{" "}
          and we'll send it your way!
        </P>
      </Flex>
    </CPanel>
  );
};

export default InvoiceMessage;
